<template>
  <div>
    <div class="modal_header">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple">
            <div class="title_h">
              {{ $t("message.patient_service") }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24">
          <div class="grid-content bg-purple-light">
            <el-row class="button_r">
              <el-button
                  :loading="waitingPrint"
                  @click="printMini(object_service.id)"
                  type="success"
              >{{ $t("message.print") }}</el-button
              >
              <el-button @click="close()">{{ $t("message.close") }}</el-button>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-main v-loading="waiting">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span> {{ $t("message.order") }}</span>
          </div>
          <div>
            <el-table :data="tableOrderData" style="width: 100%">
              <el-table-column label="№" width="110" align="center">
                <template slot-scope="scope"> # {{ scope.row.id }} </template>
              </el-table-column>
              <el-table-column prop="diagnos" :label="$t('message.clinic_diagnos')" align="center">
              </el-table-column>
              <el-table-column prop="partner_clinic.name" :label="$t('message.partner_clinic')" align="center">
              </el-table-column>
              <el-table-column prop="department.name" :label="$t('message.department')" align="center">
              </el-table-column>
              <el-table-column prop="partner_doctor.name" :label="$t('message.partner_doctor')" align="center">
              </el-table-column>
              <el-table-column prop="blok" :label="$t('message.blok')" align="center">
              </el-table-column>
              <el-table-column prop="vial_quantity" :label="$t('message.vial_quantity')" align="center">
              </el-table-column>
              <el-table-column :label="$t('message.material')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.material ? scope.row.material.name : "" }}
                </template>
              </el-table-column>
              <el-table-column prop="created_at" :label="$t('message.order_created_at')" align="center">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" class="mt-2">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span> {{ $t("message.patient") }}</span>
          </div>
          <div>
            <el-table :data="tablePatientData" style="width: 100%">
              <el-table-column label="№" width="110" align="center">
                <template slot-scope="scope"> # {{ scope.row.id }} </template>
              </el-table-column>
              <el-table-column prop="first_name" :label="$t('message.first_name')" width="150" align="center">
              </el-table-column>
              <el-table-column prop="surname" :label="$t('message.surname')" align="center">
              </el-table-column>
              <el-table-column prop="patronymic" :label="$t('message.patronymic')" align="center">
              </el-table-column>
              <el-table-column prop="born_date" :label="$t('message.dob')" align="center">
              </el-table-column>
              <el-table-column prop="gender" :label="$t('message.gender')" align="center">
              </el-table-column>
              <el-table-column prop="code" :label="$t('message.code')" align="center">
              </el-table-column>
              <el-table-column prop="phone" :label="$t('message.phone')" align="center">
              </el-table-column>
              <el-table-column :label="$t('message.social')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.social ? scope.row.social.name : "" }}
                </template>
              </el-table-column>
              <el-table-column prop="created_at" :label="$t('message.date')" align="center">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" class="mt-2">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span> {{ $t("message.address_patient") }}</span>
          </div>
          <div>
            <el-table :data="tablePatientData" style="width: 100%">
              <el-table-column :label="$t('message.country')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.state ? scope.row.state.name : "" }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.city')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.city ? scope.row.city.name : "" }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.region')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.region[0] ? scope.row.region[0].name : "" }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.street')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.street }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.house')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.home }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.flat')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.flat }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" class="mt-2">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span> {{ $t("message.order_service") }}</span>
          </div>
          <div>
            <el-table :data="[tableServicesData]" style="width: 100%">
              <el-table-column type="index" label="#" width="80" align="center">
              </el-table-column>
              <el-table-column prop="name" :label="$t('message.service_name')" width="280" align="center">
              </el-table-column>
              <el-table-column prop="price" :label="$t('message.price2')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.price | formatMoney }}
                </template>
              </el-table-column>
              <el-table-column prop="discount_price" :label="$t('message.discount')" align="center">
              </el-table-column>
              <el-table-column prop="code" :label="$t('message.code')" align="center">
              </el-table-column>
              <el-table-column prop="lifetime" :label="$t('message.lifetime_services')" align="center">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-main>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: ["drawer", "open", "object_service"],
  data() {
    return {
      waitingPrint: false,
      waiting: false,
      form: {},
      tablePatientData: [],
      tableOrderData: [],
      tableServicesData: [],
    };
  },
  watch: {
    open: {
      handler: function (newVal, oldVal) {
        if (newVal === true) {
          this.loadOrder();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      rules: "orders/rules",
      orderServiceModel: "orders/service_model",
      hospitalizationServiceModel: "hospitalizationServices/relation_model",
      columns: "orders/columns",
    }),
  },
  methods: {
    ...mapActions({
      showOrderService: "orders/serviceShow",
      showHospitalService: "hospitalizationServices/serviceShow",
    }),
    printMini(id) {
      this.waitingPrint = true;
      let vm = this;
      var jqxhr = $.get(
          process.env.VUE_APP_URL + `orders/print-mini-order?id=${id}`,
          function () {}
      )
          .done(function (res) {
            vm.waitingPrint = false;
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,toolbar=0,scrollbars=0,status=0"
            );
            WinPrint.document.write(res);
            WinPrint.document.close();
            WinPrint.focus();
            setTimeout(() => {
              WinPrint.print();
              WinPrint.close();
            }, 1000);
          })
          .fail(function () {
            alert(i18n.t("message.cannot_print"));
            vm.waitingPrint = false;
          });
    },
    loadOrder() {
      const query = { ids: this.object_service.ids, id: this.object_service.id };
      this.waiting = true;
      if (this.object_service.ids.split('-').length === 2) {
        this.showOrderService(query)
          .then((res) => {
            this.loadModel('order');
          })
          .finally((fin) => {
            this.waiting = false;
          });
      } else if (this.object_service.ids.split('-').length === 3) {
        this.showHospitalService(query)
          .then((res) => {
            this.loadModel('hospitalization');
          })
          .finally((fin) => {
            this.waiting = false;
          });
      }
    },
    loadModel(entity) {
      if (entity === 'order') {
        this.tablePatientData = [JSON.parse(JSON.stringify(this.orderServiceModel.order.patient))];
        this.tableOrderData = [JSON.parse(JSON.stringify(this.orderServiceModel.order))];
        this.tableServicesData = JSON.parse(
            JSON.stringify(this.orderServiceModel.service)
        );
      } else if(entity === 'hospitalization') {
        this.tablePatientData = [JSON.parse(JSON.stringify(this.hospitalizationServiceModel.patient))];
        this.tableOrderData = [JSON.parse(JSON.stringify(this.hospitalizationServiceModel.patient_history))];
        this.tableServicesData = JSON.parse(
            JSON.stringify(this.hospitalizationServiceModel.service)
        );
      }
    },
    close() {
      this.$emit("c-close", { drawer: "drawerOrderShow" });
    },
    parent() {
      return this.$parent.$parent;
    },
  },
};
</script>